import React, { useState } from "react";
import { describeHistoryEntry, formatWhen, roleLabel } from "../../approvals/approvalMeta";

const TONE = {
  teacher: "border-blue-200 bg-blue-50",
  hod: "border-amber-200 bg-amber-50",
  admin: "border-emerald-200 bg-emerald-50",
};

/** Feedback conversation + audit trail for one plan (reviewer view). */
export default function ActivityPanel({ thread = [], history = [] }) {
  const [tab, setTab] = useState(thread.length ? "feedback" : "history");
  const rows = [...history].reverse();
  return (
    <section className="rounded-xl border border-slate-200 bg-white" aria-label="Plan activity">
      <div className="flex gap-1 border-b border-slate-200 px-3">
        {[
          { key: "feedback", label: `Feedback${thread.length ? ` (${thread.length})` : ""}` },
          { key: "history", label: "History" },
        ].map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            aria-pressed={tab === t.key}
            className={`-mb-px border-b-2 px-3 py-2.5 text-[13px] font-semibold ${
              tab === t.key ? "border-[#1565c0] text-[#1565c0]" : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="max-h-[420px] overflow-y-auto p-4">
        {tab === "feedback" &&
          (thread.length ? (
            <div className="space-y-2">
              {thread.map((m, i) => (
                <div key={`${m.timestamp}-${i}`} className={`rounded-lg border p-3 ${TONE[m.role] || "border-slate-200 bg-slate-50"}`}>
                  <div className="mb-1 flex justify-between text-[11px] text-slate-500">
                    <span className="font-semibold text-slate-700">{roleLabel(m.role)}{m.actor ? ` · ${m.actor}` : ""}</span>
                    <span>{formatWhen(m.timestamp)}</span>
                  </div>
                  <div className="whitespace-pre-wrap text-[13px] text-slate-800">{m.text}</div>
                </div>
              ))}
            </div>
          ) : (
            <p className="m-0 text-[13px] text-slate-500">No feedback yet.</p>
          ))}
        {tab === "history" &&
          (rows.length ? (
            <ol className="relative m-0 ml-2 list-none border-l border-slate-200 p-0">
              {rows.map((h, i) => (
                <li key={`${h.at}-${i}`} className="mb-4 ml-4">
                  <span className="absolute -left-[5px] mt-1.5 h-2.5 w-2.5 rounded-full border border-white bg-[#1565c0]" />
                  <div className="text-[13px] font-semibold text-slate-800">{describeHistoryEntry(h)}</div>
                  <div className="text-[11px] text-slate-500">
                    {h.actor_name || "Unknown"} · {roleLabel(h.role)} · {formatWhen(h.at)}{h.revision ? ` · r${h.revision}` : ""}
                  </div>
                  {h.reason && <div className="mt-1 rounded-md bg-slate-50 p-2 text-[12px] text-slate-700">{h.reason}</div>}
                </li>
              ))}
            </ol>
          ) : (
            <p className="m-0 text-[13px] text-slate-500">No activity recorded yet.</p>
          ))}
      </div>
    </section>
  );
}
